import { render, staticRenderFns } from "./AssessmentEntry.vue?vue&type=template&id=041487d9"
import script from "./AssessmentEntry.vue?vue&type=script&lang=js"
export * from "./AssessmentEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports